import { AlertTriangle } from 'lucide-react';
import { useCreditsContext } from '../../contexts/CreditsContext';
import { useUser } from '../../contexts/UserContext';

export function CreditWarningBanners() {
  const { isAdmin } = useUser();
  const { credits, isSubscriber, setShowPricingModal } = useCreditsContext();

  // Low Credit Warning Banner
  if (!isAdmin && !isSubscriber && credits <= 2 && credits > 0) {
    return (
      <div className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-b border-amber-500/30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-amber-200">
            <AlertTriangle className="h-4 w-4 flex-shrink-0" />
            <span className="text-sm">
              Running low! {credits} {credits === 1 ? 'analysis' : 'analyses'} remaining.
            </span>
          </div>
          <button
            onClick={() => setShowPricingModal(true)}
            className="text-sm font-medium text-amber-400 hover:text-amber-300 transition whitespace-nowrap"
          >
            Get more credits
          </button>
        </div>
      </div>
    );
  }

  // Zero Credits Warning Banner
  if (!isAdmin && !isSubscriber && credits === 0) {
    return (
      <div className="bg-gradient-to-r from-red-500/20 to-pink-500/20 border-b border-red-500/30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-red-200">
            <AlertTriangle className="h-4 w-4 flex-shrink-0" />
            <span className="text-sm">
              You're out of credits! Purchase more to continue.
            </span>
          </div>
          <button
            onClick={() => setShowPricingModal(true)}
            className="text-sm font-medium bg-red-500 hover:bg-red-400 text-white px-3 py-1.5 rounded-lg transition whitespace-nowrap w-fit"
          >
            Buy Credits
          </button>
        </div>
      </div>
    );
  }

  return null;
}
